import { ResponseDto } from '@diritto/common/base/response.dto';
import { ContentAuthorReplyApi } from 'api/ApiHelper';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useDeleteReplyByAuthorMutation = (
  contentId: number,
  options?: UseMutationOptions<ResponseDto, unknown, number>,
) => useMutation({ mutationFn: (id: number) => ContentAuthorReplyApi.deleteReply(contentId, id), ...options });
